const initailState = {
  allBidsdata: [],
  loadings: false,
};

export function bidsReducer(state = initailState, { type, payload }) {
  switch (type) {
    case "GETTING_BIDS":
      return { ...state, loadings: true };
    case "GETTED_BIDS":
      return { ...state, loadings: false };
    case "BIDS_DETAILS":
      return { ...state, allBidsdata: payload, loadings: false };

    default:
      return state;
  }
}

export function raisePickupReducer(
  state = {
    loadings: false,
  },
  { type, payload }
) {
  switch (type) {
    case "GETTING_RAISE_PICKUP":
      return { ...state, loadings: true };
    case "GETTED_RAISE_PICKUP":
      return { ...state, loadings: false };
    case "RAISE_PICKUP_REQUEST":
      return { ...state, loadings: false };

    default:
      return state;
  }
}

export function allPickupDetailsReducer(
  state = {
    allPickup: [],
    loadings: false,
  },
  { type, payload }
) {
  switch (type) {
    case "GETTING_ALL_PICKUP":
      return { ...state, loadings: true };
    case "GETTED_ALL_PICKUP":
      return { ...state, loadings: false, allPickup: [] };
    case "ALL_PICKUP_DETAILS":
      return { ...state, allPickup: payload, loadings: false };

    default:
      return state;
  }
}

export function cancelPickupReducer(
  state = {
    loadings: false,
  },
  { type, payload }
) {
  switch (type) {
    case "GETTING_CANCEL_PICKUP":
      return { ...state, loadings: true };
    case "GETTED_CANCEL_PICKUP":
      return { ...state, loadings: false };
    case "CANCEL_PICKUP_REQUEST":
      return { ...state, loadings: false };
    case "GETTING_ACCEPT_PICKUP":
      return { ...state, loadings: true };
    case "GETTED_ACCEPT_PICKUP":
      return { ...state, loadings: false };
    case "ACCEPT_PICKUP_REQUEST":
      return { ...state, loadings: false };

    default:
      return state;
  }
}
